module.exports = __webpack_public_path__ + "img/card3.8637bd11.png";